
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_93P5Zw6J6PE8Meta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/[slug].vue?macro=true";
import { default as _404V1yz7961eaMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/404.vue?macro=true";
import { default as _500hfrLjrR9LmMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/500.vue?macro=true";
import { default as _91slug_93PcTlTdtM1gMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/blog/[slug].vue?macro=true";
import { default as index5F1mcERS7LMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/blog/index.vue?macro=true";
import { default as contactFYHPHqGauQMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/contact.vue?macro=true";
import { default as employer9ed5MGsjNEMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/employer.vue?macro=true";
import { default as index4PrmckExQEMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/index.vue?macro=true";
import { default as prospect_form_employer_candidatexvHoXQhYezMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/prospect_form_employer_candidate.vue?macro=true";
import { default as prospect_form_employer3TsjJFbcUIMeta } from "/mnt/agent/work/a3eaf6f60f6858aa/pages/prospect_form_employer.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93P5Zw6J6PE8Meta || {},
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/[slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/404.vue")
  },
  {
    name: "500",
    path: "/500",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/500.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: index5F1mcERS7LMeta || {},
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/blog/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/contact.vue")
  },
  {
    name: "employer",
    path: "/employer",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/employer.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index4PrmckExQEMeta || {},
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/index.vue")
  },
  {
    name: "prospect_form_employer_candidate",
    path: "/prospect_form_employer_candidate",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/prospect_form_employer_candidate.vue")
  },
  {
    name: "prospect_form_employer",
    path: "/prospect_form_employer",
    component: () => import("/mnt/agent/work/a3eaf6f60f6858aa/pages/prospect_form_employer.vue")
  }
]